export class NotificationsCounterApiModel {
  public TotalCount = 0;
  public UnreadCount = 0;
}
